
import * as angular from "angular";

export function positiveFilter() {

    return (input: number) => {

        if (!input) {
            return 0;
        }

        return Math.abs(input);
    }
}
